"use client";
import { createContext } from 'react';

const MotionContext = /* @__PURE__ */ createContext({});

export { MotionContext };
//# sourceMappingURL=index.mjs.map
